





















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class UOnboardScreen extends Vue {
  @Prop({ required: true })
  public title!: string;

  @Prop({ required: true })
  public desc!: string;

  @Prop({ default: null })
  public cta!: string;

  @Prop({ required: true })
  public img!: string;

  @Prop({ default: false })
  public ctaDisabled!: boolean;

  public click() {
    if (this.ctaDisabled) {
      return;
    }

    this.$emit("click");
  }
}
